import { useGlobalTopicFilterModel } from './global-topic-filter.model'
import { GlobalTopicFilterView } from './global-topic-filter.view'

export const GlobalTopicFilter = () => {
  const globalTopicFilterModel = useGlobalTopicFilterModel()
  return <GlobalTopicFilterView {...globalTopicFilterModel} />
}
